<template>
  <div>
    <RecordNotFound
      v-if="status_code == 404"
      :message="status_message"
    ></RecordNotFound>
    <template v-else>
      <div v-if="is_no_records == 1">
        <GlobalEmptyRecord RouteName="BankingCreate">
          <template slot="title">
            <h2>All Your Banking at one place!!!</h2>
          </template>
          <template slot="content">
            <span style="color: gray">Personalize your business Accounts</span>
          </template>
          <template slot="page">Add Bank or Credit Card</template>
        </GlobalEmptyRecord>
      </div>
      <div class="start-page" v-else style="margin-top: -10px !important">
        <b-row class="px-pad border-bottom" style="height: 42px">
          <b-col cols="8" class="px-0"
            ><span class="fw-semi-bold index-heading pl-0">Banking</span>
          </b-col>
          <b-col cols="4" class="text-right px-0">
            <b-button
              v-if="RoutePermission(false, '', '', 'banking', 'create')"
              variant="primary"
              size="sm"
              class="mr-2"
              :to="{ name: 'BankingCreate' }"
            >
              Add Bank or Credit Card
            </b-button>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12" class="px-0">
            <div :class="'table-responsive'" id="scrollCol">
              <table class="table table-hover index-table not-fixed-col">
                <thead>
                  <tr>
                    <th style="padding-left: 1.6rem !important">
                      Account Name
                    </th>

                    <th>Account Code</th>
                    <th>Account Number</th>
                    <th>Currency</th>
                    <th>Bank Name</th>
                    <th style="width: 30px !important" class="text-right"></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="lists.length == 0">
                    <td colspan="5" class="text-center">No data to display</td>
                  </tr>
                  <tr v-else v-for="list in lists" :key="list.id">
                    <td style="padding-left: 1.6rem !important">
                      <router-link
                        :to="{ name: 'BankingUpdate', params: { id: list.id } }"
                        v-if="
                          RoutePermission(false, '', '', 'banking', 'update')
                        "
                      >
                        {{ list.acc_name }}
                      </router-link>
                      <template v-else>
                        {{ list.acc_name }}
                      </template>
                    </td>

                    <td>{{ list.acc_code }}</td>
                    <td>{{ list.acc_number }}</td>
                    <td>
                      {{
                        getDetails(
                          $AppDetails.currency_details,
                          list.currency,
                          "currency_name"
                        )
                      }}
                    </td>
                    <td>{{ list.bank_name }}</td>
                    <td style="width: 30px !important" class="text-right">
                      <b-dropdown
                        right
                        toggle-class="text-decoration-none"
                        variant="link"
                        no-caret
                        size="xs"
                        class="table-hover-visible last-td-arrow"
                        v-if="
                          RoutePermission(false, '', '', 'banking', 'update') ||
                          RoutePermission(false, '', '', 'banking', 'delete')
                        "
                      >
                        <template slot="button-content">
                          <i
                            class="glyphicon glyphicon-option-vertical theme-text-color"
                            style="
                              top: -6px !important;
                              letter-spacing: -5px !important;
                            "
                          ></i>
                        </template>
                        <b-dropdown-item
                          v-if="
                            RoutePermission(false, '', '', 'banking', 'update')
                          "
                          :to="{
                            name: 'BankingUpdate',
                            params: { id: list.id },
                          }"
                          >Edit</b-dropdown-item
                        >
                        <b-dropdown-item
                          v-b-modal.delete
                          @click="
                            (selected_id = list.id), (modalPage = 'delete')
                          "
                          v-if="
                            RoutePermission(false, '', '', 'banking', 'delete')
                          "
                          >Delete</b-dropdown-item
                        >
                        <b-dropdown-item
                          v-b-modal.statusPage
                          @click="
                            (statusPage =
                              list.active_status_id == 1
                                ? 'inactive'
                                : 'active'),
                              (modalPage = 'status'),
                              (selected_id = list.id)
                          "
                          v-if="
                            RoutePermission(false, '', '', 'banking', 'update')
                          "
                        >
                          Mark as
                          {{
                            list.active_status_id == 1 ? "Inactive" : "Active"
                          }}
                        </b-dropdown-item>
                      </b-dropdown>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </b-col>
        </b-row>
        <b-row
          v-if="lists.length > 0"
          style="width: 100%; position: absolute; border-top: 1px solid #e0e0e0"
          class="px-pad"
        >
          <b-col xl="5" md="6" lg="6" sm="8" cols="8" class="mt-2 pt-1 px-0">
            <nav class="float-left">
              <p>
                Showing {{ total_count != 0 ? (page - 1) * count + 1 : 0 }} to
                {{ (page - 1) * show + lists.length }} of
                {{ total_count }} entries
                <span>
                  <b-dropdown
                    variant="link"
                    toggle-class="text-decoration-none"
                    size="xs"
                    :text="count"
                    left
                  >
                    <router-link
                      :to="{
                        name: 'Banking',
                        query: {
                          page: 1,
                          show: 10,
                        },
                      }"
                      class="text-decoration-none"
                    >
                      <b-dropdown-item-button
                        class="page-link"
                        v-if="count != 10"
                        >10</b-dropdown-item-button
                      >
                    </router-link>
                    <router-link
                      :to="{
                        name: 'Banking',
                        query: {
                          page: 1,
                          show: 25,
                        },
                      }"
                      class="text-decoration-none"
                    >
                      <b-dropdown-item-button
                        class="page-link"
                        v-if="count != 25"
                        >25</b-dropdown-item-button
                      >
                    </router-link>
                    <router-link
                      :to="{
                        name: 'Banking',
                        query: {
                          page: 1,
                          show: 50,
                        },
                      }"
                      class="text-decoration-none"
                    >
                      <b-dropdown-item-button
                        class="page-link"
                        v-if="count != 50"
                        >50</b-dropdown-item-button
                      >
                    </router-link>
                  </b-dropdown>
                </span>
                rows per page
              </p>
            </nav>
          </b-col>
          <b-col
            xl="2"
            md="2"
            lg="2"
            sm="4"
            cols="4"
            style="text-align: center"
            class="mt-2 pt-1 px-0"
          >
            <div v-if="arrow">
              <a @click="left('#scrollCol')" class="mr-2">
                <i class="fa fa-angle-left mr-1 fw-bold round-icon"></i>

                <!-- <b-badge class="badge" variant="light">&lt;</b-badge> -->
              </a>
              <a @click="right('#scrollCol')">
                <i class="fa fa-angle-right ml-1 fw-bold round-icon"></i>

                <!-- <b-badge class="badge" variant="light">&gt;</b-badge> -->
              </a>
            </div>
          </b-col>
          <b-col
            xl="5"
            md="4"
            lg="4"
            sm="12"
            class="mt-2 pt-1 px-0 d-md-block d-none"
          >
            <template v-if="total_count > show">
              <nav class="float-right">
                <ul class="pagination">
                  <li class="page-item">
                    <template v-if="page != 1">
                      <router-link
                        class="page-link"
                        :to="{
                          name: 'Banking',
                          query: {
                            page: page - 1,
                            show: count,
                          },
                        }"
                      >
                        <span aria-hidden="true">&laquo;</span>
                        <span class="sr-only">Previous</span>
                      </router-link>
                    </template>
                    <template v-else>
                      <a class="page-link" href="#" aria-label="Previous">
                        <span aria-hidden="true">&laquo;</span>
                        <span class="sr-only">Previous</span>
                      </a>
                    </template>
                  </li>
                  <li class="page-item">
                    <router-link
                      class="page-link"
                      :to="{
                        name: 'Banking',
                        query: {
                          page: 1,
                          show: count,
                        },
                      }"
                      >First</router-link
                    >
                  </li>
                  <li class="page-item">
                    <template v-if="page != 1">
                      <router-link
                        class="page-link"
                        :to="{
                          name: 'Banking',
                          query: {
                            page: page - 1,
                            show: count,
                          },
                        }"
                        >Previous</router-link
                      >
                    </template>
                    <template v-else>
                      <a href="#" class="page-link">Previous</a>
                    </template>
                  </li>
                  <li class="page-item">
                    <template v-if="total_count > page * count">
                      <router-link
                        class="page-link"
                        :to="{
                          name: 'Banking',
                          query: {
                            page: page + 1,
                            show: count,
                          },
                        }"
                        >Next</router-link
                      >
                    </template>
                    <template v-else>
                      <a href="#" class="page-link">Next</a>
                    </template>
                  </li>
                  <li class="page-item">
                    <router-link
                      class="page-link"
                      :to="{
                        name: 'Banking',
                        query: {
                          page: Math.ceil(total_count / count),
                          show: count,
                        },
                      }"
                      >Last</router-link
                    >
                  </li>
                  <li class="page-item">
                    <template v-if="total_count > page * count">
                      <router-link
                        class="page-link"
                        :to="{
                          name: 'Banking',
                          query: {
                            page: page + 1,
                            show: count,
                          },
                        }"
                      >
                        <span aria-hidden="true">&raquo;</span>
                        <span class="sr-only">Next</span>
                      </router-link>
                    </template>
                    <template v-else>
                      <a class="page-link" href="#" aria-label="Next">
                        <span aria-hidden="true">&raquo;</span>
                        <span class="sr-only">Next</span>
                      </a>
                    </template>
                  </li>
                </ul>
              </nav>
            </template>
          </b-col>
        </b-row>
        <b-modal
          id="delete"
          body-class="bg-white"
          cancel-title="Cancel"
          cancel-variant="light"
          :ok-title-html="submitted == true ? loaderIcon + 'Yes' : 'Yes'"
          title="Bulk Delete"
          @ok="handledelete"
          :ok-disabled="submitted"
        >
          <p>Are you sure you want to delete this account ?</p>
        </b-modal>
        <b-modal
          id="statusPage"
          body-class="bg-white"
          cancel-title="Cancel"
          cancel-variant="light"
          :ok-title-html="submitted == true ? loaderIcon + 'Yes' : 'Yes'"
          title="Status"
          @ok="handledelete"
          :ok-disabled="submitted"
        >
          <p>
            Are you sure you want to {{ statusPage }} the selected account ?
          </p>
        </b-modal>
      </div>
    </template>
  </div>
</template>
<script>
import store from "@/store/index";
import { mapState } from "vuex";
import { scrollTable } from "@/mixins/scrollTable"; //functions call for table scroll
import { notificationMixin } from "@/mixins/notification";
import { formatDate } from "@/mixins/formatDate"; // to formatdate in y-m-d
import RecordNotFound from "@/pages/Error/RecordNotFound";
function getPageAccounts(routeTo, next) {
  const currentPage = parseInt(routeTo.query.page) || 1;
  const show = parseInt(routeTo.query.show) || 10;
  store
    .dispatch("banking/fetchBankingList", {
      page: currentPage,
      show: show,
    })
    .then(() => {
      routeTo.params.page = currentPage;
      routeTo.params.show = show;
      next();
    });
}

export default {
  mixins: [notificationMixin, scrollTable, formatDate],
  props: {
    page: {
      type: Number,
      required: true,
    },
    show: {
      type: Number,
      required: true,
    },
  },
  components: {
    RecordNotFound,
  },
  data() {
    return {
      arrow: false,
      is_no_records: 0,
      submitted: false,
      statusPage: "Inactive",
      selected_id: "",
      loaderIcon: `<i class="fa fa-circle-o-notch fa-spin mr-2"></i>`,
      modalPage: "",
    };
  },
  methods: {
    handledelete() {
      this.submitted = true;

      const currentPage = parseInt(this.$route.query.page) || 1;
      const show = parseInt(this.$route.query.show) || 10;

      var url, data;
      if (this.modalPage == "delete") {
        url = "bankingdelete";
        data = { id: this.selected_id };
      } else if (this.modalPage == "status") {
        url = "bankingstatus";
        data = JSON.stringify({
          type: this.statusPage,
          id: this.selected_id,
        });
      }

      store.dispatch("banking/" + url, data).then((response) => {
        this.submitted = false;
        window.Messenger().post({
          extraClasses: "messenger-fixed messenger-on-top messenger-on-center",
          message: response.data.status,
          type: response.data.type,
          showCloseButton: true,
        });
        store
          .dispatch("banking/fetchBankingList", {
            page: currentPage,
            show: show,
          })
          .then(() => {
            this.$route.params.page = currentPage;
            this.$route.params.show = show;
          })
          .then(async () => {
            this.page = await (this.lists.length == 0 && this.page != 1
              ? (this.page = 1)
              : this.page);
            this.show = show;

            await this.$router.push({
              query: {
                page: this.page,
                show: this.show,
              },
            });
          });
      });
    },
    //selectall the checkbox//
  },
  updated() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  mounted() {
    this.arrow = this.scrollbar($("#scrollCol")) ? true : false;
  },
  beforeRouteEnter(routeTo, routeFrom, next) {
    getPageAccounts(routeTo, next);
  },
  beforeRouteUpdate(routeTo, routeFrom, next) {
    getPageAccounts(routeTo, next);
    // ...
  },
  computed: {
    ...mapState({
      lists: (state) => state.banking.lists,
      total_count: (state) => state.banking.total_count,
      count: (state) => state.banking.count,
      status_code: (state) => state.banking.status_code,
      status_message: (state) => state.banking.status_message,
      status_type: (state) => state.banking.status_type,
    }),
  },
};
</script>